import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=b007e50e&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=b007e50e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b007e50e",
  null
  
)

export default component.exports